import axios from "axios";

const AuthStr = "Bearer " + localStorage.getItem("token");

function getApiCall(url) {
    return axios
        .get(process.env.REACT_APP_API_KEY + url, {
            headers: { Authorization: AuthStr },
        })
        .then((data) => {
            return data;
        });
}

function getV2ApiCall(url) {
    return axios
        .get(process.env.REACT_APP_API_KEY2 + url, {
            headers: { Authorization: AuthStr },
        })
        .then((data) => {
            return data;
        });
}

function postApiCall(url, body) {
    return axios
        .post(process.env.REACT_APP_API_KEY + url, body, {
            headers: { Authorization: AuthStr },
        })
        .then((data) => {
            return data;
        });
}

function putApiCall(url, body) {
    return axios
        .put(process.env.REACT_APP_API_KEY + url, body, {
            headers: { Authorization: AuthStr },
        })
        .then((data) => {
            return data;
        });
}

function deleteApiCall(url, body) {
    return axios.delete(process.env.REACT_APP_API_KEY + url, {
        headers: { Authorization: AuthStr },
        data: body
    }).then((data) => {
        return data;
    });
}


export { getApiCall, postApiCall, putApiCall, deleteApiCall, getV2ApiCall };
